/**
 * Base class for welcome screens
 * Shows background design with bubbles
 * show arrows back / next
 */
fx.ns("shared.screens", class BaseChoiceScreen extends fx.components.PopupPanel
{
    constructor(options)
    {
        super();

        this._showBack = options && options.back !== undefined ? options.back : true;
        this._showNext = options && options.next !== undefined ? options.next : true;

        this.mode = "";

        this.showEffect = "hslideout";
		this.hideEffect = "hslidein";

        this.destroyOnSwitch = true;

        this._containerHeight = "fill";

        this._styleChoice = "circle"; // circle or square

        this._choices = [];
    }

    get title()
    {
        return this._title;
    }

    set title(val)
    {
        this._title = val;
    }

    get containerHeight()
    {
        return this._containerHeight;
    }

    set containerHeight(val)
    {
        this._containerHeight = val;
    }

    get styleChoice()
    {
        return this._styleChoice;
    }

    set styleChoice(val)
    {
        this._styleChoice = val;
    }


    get choices()
    {
        return this._choices;
    }

    set choices(val)
    {
        this._choices = val;
    }

    get currentChoice()
    {
        return this._currentChoice;
    }

    set currentChoice(val)
    {
        this._currentChoice = val;
    }

    get showBack()
    {
        return this._showBack;
    }

    set showBack(value)
    {
        this._showBack = value;
        this._updateNavigation();
    }

    get showNext()
    {
        return this._showNext;
    }

    set showNext(value)
    {
        this._showNext = value;
        this._updateNavigation();
    }

    get valign()
    {
        return this._valign;
    }

    // set vertical align
    set valign(val)
    {
        this._valign = val;
        this._setAlign();
    }

    // to override
    onChoiceClicked(choice)
    {

    }


    create()
    {
        super.create();

        if (this._showBack)
        {
            this.backButton = new fx.components.Button({label: fx.text("Revenir"), icon : fx.get("assets").arrowBack, className : "navigation"});
            this.addChild( this.backButton, {top : 0, left : 0});
        }

        if (this._showNext)
        {
            this.nextButton = new fx.components.Button({label: fx.text("Passer"), className : "navigation"});
            this.addChild( this.nextButton, {top : 0, right : 10});
        }

        if (this.choices.length > 0)
            this.build();
    }

    build()
    {
        this.container = new fx.components.VBox("container " + (fx.browser.isDesktop ? "horizontal" : "vertical"));
        this.addChild( this.container, {top : fx.browser.isDesktop ? "center" : 50, left : 0, width : "100%", height : fx.browser.isDesktop ? this.containerHeight : "fill"});        

        this.addTitle( this.title );

        if (fx.browser.isDesktop)
        {
            this.hContainer = new fx.components.HBox({align:"center"});
            this.hContainer.valign = this.valign;
            this.container.addChild(this.hContainer, {width:"100%", height: "fill"});

            this._setAlign();
        }
      
        for (let i = 0; i < this.choices.length; i++)
        {
            let choice = this.choices.getItemAt(i);

            let component = new shared.components.ProductChoice(this.styleChoice, choice.data, choice.asset, choice.name, choice.description, choice.price);
            
            if (this._currentChoice && choice.data == this._currentChoice)
                component.addClass("selected")

            this.addChoice(component);
        }
    }

    addTitle(text)
    {
        this.container.addChild( new fx.components.Text( {text : text , className : "title" } ), {width:"90%", height : fx.browser.isDesktop ? 80 : 65, left:"center"});
    }

    addChoice(choice, viewport)
    {
        if (fx.browser.isDesktop)
            this.hContainer.addChild( choice, viewport || {width: 190, height : 270} );
        else
            this.container.addChild( choice, viewport || {width: 190, height : 270, left : "center"} );
    }

    onReady()
    {
        super.onReady();

        this._updateNavigation();

        if (this.backButton)
            this.on("click", this.onBack, this.backButton);

        if (this.nextButton)
            this.on("click", this.onNext, this.nextButton);

        this.on("click", this.onClick, this.container);
    }


    _updateNavigation()
    {
        if (this.backButton)
            this.backButton.toggle(this._showBack);

        if (this.nextButton)
            this.nextButton.toggle(this._showNext);
    }

    _setAlign()
    {
        if (!this.initialized)
            return;

        this.hContainer.valign = this.valign;
    }

    onClick(e)
    {
        let element = fx.dom.parent(e.target, ".ProductChoice");
        if (element)
        {
            let data = this.getChildFromUI(element).data;
            this.onChoiceClicked( data );
        }
    }

    onBack()
    {
        if (this.data)
            this.data.event("previous-step");
    }

    onNext()
    {
        if (this.data)
            this.data.event("next-step");
    }

});
    